import { createFeatureSelector, createSelector } from '@ngrx/store';

import { UserState } from '../reducers/user';

const getUserFeatureState = createFeatureSelector<UserState>('user');

export const getCurrentUser = createSelector(getUserFeatureState, (state) => state.currentUser);

export const getAllUsers = createSelector(getUserFeatureState, (state) => state.allUsers);

export const getCurrentUserDetails = createSelector(getUserFeatureState, (state) => state.userDetails);

export const getUserFilter = createSelector(getUserFeatureState, (state) => state.filter);

export const getFilteredUsers = createSelector(getAllUsers, getUserFilter, (users, filter) => {
  if (!filter) return users;
  const search = filter.trim().toLowerCase();
  return users.filter(
    (user) =>
      user.username?.toLowerCase().includes(search) ||
      user.fullName?.toLowerCase().includes(search) ||
      user.sapId?.toLowerCase().includes(search),
  );
});
